export const languagesLocaleEnabled = () => {
  const { REACT_APP_LanguagesEnabled: LanguagesEnabled } = process.env;

  return LanguagesEnabled.split(",").map((language) => language.trim());
};
